"use client";

import React from "react";
import { Clock, Plus, User } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const offerings = [{
  id: "private",
  title: "Einzelstunden & Coaching",
  price: "45€ / Std.",
  description: "Manchmal erfordert der persönliche Weg eine besondere Aufmerksamkeit. Im Einzelunterricht widmen wir uns ganz deinen individuellen Bedürfnissen – ob zur präzisen Vertiefung deiner Praxis, dem Erlernen einer Form, die dich interessiert, oder der Arbeit an einer speziellen Herausforderung. In der Ruhe unseres Studios schaffen wir Raum für deinen Fortschritt.",
  image: "https://huge-sunbird.10web.cloud/wp-content/uploads/2026/04/IMG-20250921-WA0014.jpg",
  label1Text: "Individuell",
  label1Icon: "user",
  label2Text: "Flexibel",
  label2Icon: "clock",
  buttonText: "Jetzt anfragen",
  link: "mailto:post@tai-chi-soonwald.de?subject=Anfrage%20Einzelstunden%20%26%20Coaching"
}];
const getIcon = (name: string) => {
  switch (name) {
    case "user":
      return <User className="w-3 h-3 mr-1" />;
    case "clock":
      return <Clock className="w-3 h-3 mr-1" />;
    default:
      return null;
  }
};
export default function SeminarsAndPrivateLessons() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="einzelstunden-coaching" className="py-20 md:py-24 bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
              Individuelle Begleitung
            </h2>
            <p className="text-lg text-muted-foreground">
              Ganzheitliche Entwicklung im eigenen Rhythmus.
            </p>
          </div>

          <div className="flex justify-center">
            {offerings.map((item, i) => <Card key={item.id} data-index={i} className="max-w-2xl overflow-hidden border-border shadow-[0px_10px_30px_0px_rgba(0,0,0,0.05)] flex flex-col">
                <img src={item.image} alt={item.title} className="w-full aspect-video object-cover" />
                <CardContent className="pt-6 flex-grow flex flex-col gap-4">
                  <div className="flex flex-wrap gap-2">
                    <Badge variant="secondary" className="bg-secondary/50 text-muted-foreground font-normal">
                      {getIcon(item.label1Icon)}
                      {item.label1Text}
                    </Badge>
                    <Badge variant="secondary" className="bg-secondary/50 text-muted-foreground font-normal">
                      {getIcon(item.label2Icon)}
                      {item.label2Text}
                    </Badge>
                  </div>
                  <div className="flex justify-between items-start gap-4">
                    <CardTitle className="text-2xl text-primary">
                      {item.title}
                    </CardTitle>
                    <span className="font-bold text-primary text-lg whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {item.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pb-6">
                  <Button variant="outline" className="w-full sm:w-auto border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors" asChild>
                    <a href={item.link}>
                      <Plus className="mr-2 h-4 w-4" />
                      {item.buttonText}
                    </a>
                  </Button>
                </CardFooter>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}